export const upperCase = (param) => {
  const str = param.toLowerCase();
  const first = str.substring(0, 1).toUpperCase();
  const last = str.substring(1, str.length);
  return first + last;
};
